import axios from 'axios'
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getItem, getItemToken } from '../../Utils/localStorageUtils';
import { initializeI18n } from '../../Utils/Translate';
import { filterKidsContent, filterKidsObjectArrays } from '../../Utils/kidsFilter';
import { toast } from 'react-toastify';
const footerAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Footer-index`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        await dispatch({ type: "GET_FOOTER_LINKS", payload: response?.data });
    }
    catch (error) {
        await dispatch({ type: "GET_FOOTER_FAILED", payload: error });
    };
}

const homeBannerAction = (sections) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/sliders`,
            {
                Login_device_type: "web",
                limit: 15,
                page: 1,
                sliders_source: sections,
            },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            }
        )
        const ListRes = response?.data
        await dispatch({ type: "GET_HOMEBANNER", payload: [...ListRes?.AdminSliders?.data, ...ListRes?.videos_sliders?.data, ...ListRes?.Series_sliders?.data, ...ListRes?.Episode_sliders?.data, ...ListRes?.LiveStream_sliders?.data, ...ListRes?.Audios_sliders?.data] });
        await dispatch({ type: "GET_ADMINBANNER", payload: response?.data?.AdminSliders });
    }
    catch (error) {
        await dispatch({ type: "GET_HOMEBANNER_FAILED", payload: error });
    };
}

const viewAllAction = (data) => async (dispatch) => {
    try {
        dispatch({ type: "GET_VIEWALL", payload: [data] });
    }
    catch (error) {
        dispatch({ type: "GET_VIEWALL_FAILED", payload: error });
    };
}

const settingAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Settings`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        if (response?.data?.setting) {
            let result = response?.data?.setting;
            if (result?.access_free !== undefined) {
                result.access_free = Number(result.access_free);
            } else {
                console.warn('access_free property is missing or undefined');
            }
            result.pushnotification_status = response?.data?.pushnotification_status;
            result.slider_settings = response?.data?.slider_settings;
            result.script_setting = response?.data?.script_setting;
            await dispatch({ type: "GET_SETTING", payload: result });
        } else {
            console.error('Settings data not found in the response');
        }

    } catch (error) {
        console.error('Error fetching settings:', error);
        await dispatch({ type: "GET_SETTING_FAILED", payload: error.message });
    }
};
const labelAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Label-Management/list-depends-source`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        if (response?.data?.status) {
            let result = response?.data?.label_management;
            await dispatch({ type: "GET_LABEL", payload: result });
        } else {
            console.error('label data not found in the response');
        }

    } catch (error) {
        console.error('Error fetching label:', error);
        await dispatch({ type: "GET_LABEL_FAILED", payload: error.message });
    }
};

const filterAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Filter-Index`, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', } })
        let result = response?.data;
        dispatch({ type: "GET_FILTER", payload: result });
        return result;
    }
    catch (error) {
        dispatch({ type: "GET_FILTER_FAILED", payload: error });
    };
}
const siteThemeAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Site-theme`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        let result = response?.data?.Site_theme;
        await dispatch({ type: "GET_SITETHEME", payload: result });
    }
    catch (error) {
        await dispatch({ type: "GET_SITETHEME_FAILED", payload: error });
    };
}
const displayTranslateLanguageAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Translate-Languages`, {},
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            })
        let result = response?.data?.Translate_Languages;
        dispatch({ type: "GET_DISPLAYTRANSLATELANGUAGE", payload: result });
    }
    catch (error) {
        dispatch({ type: "GET_DISPLAYTRANSLATELANGUAGE_FAILED", payload: error });
    };
}

const getUserTranslateLanguageAction = (navigation) => async (dispatch) => {
    dispatch({ type: "GET_USERTRANSLATELANGUAGEACTION_REQUEST" });
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/User-Translate-Language`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
        }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', } }
        )
        const languageResponse = response?.data;
        const currentPath = window.location.pathname;
        const langCode = languageResponse?.Language_Code || 'en';
        
        // Split path and filter empty segments to handle leading/trailing slashes
        let pathSegments = currentPath.split('/').filter(Boolean);
        
        // Deduplicate: If the first two segments are the same language code, remove one (e.g., /tr/tr/ -> /tr/)
        if (pathSegments.length >= 2 && pathSegments[0].toLowerCase() === langCode.toLowerCase() && pathSegments[1].toLowerCase() === langCode.toLowerCase()) {
            pathSegments.shift();
        }

        // Check if the first segment is a language code (2-3 letters, case-insensitive)
        const hasLangPrefix = pathSegments.length > 0 && /^[a-z]{2,3}$/i.test(pathSegments[0]);
        
        let newPath;
        if (hasLangPrefix) {
            // Replace or normalize existing prefix
            pathSegments[0] = langCode.toLowerCase();
            newPath = '/' + pathSegments.join('/');
        } else {
            // Prepend new prefix
            newPath = '/' + langCode.toLowerCase() + (currentPath.startsWith('/') ? currentPath : '/' + currentPath);
        }

        // Final safety check: ensure we didn't accidentally double up (e.g. from currentPath already starting with code but hasLangPrefix failing)
        if (newPath.startsWith(`/${langCode}/${langCode}/`)) {
            newPath = newPath.replace(`/${langCode}/${langCode}/`, `/${langCode}/`);
        } else if (newPath === `/${langCode}/${langCode}`) {
            newPath = `/${langCode}`;
        }

        // Only navigate if the path has actually changed to avoid redundant reloads
        if (currentPath !== newPath) {
            await navigation(newPath);
        }
        await initializeI18n(languageResponse)
        // Persist language preference for immediate synchronous access on next load
        if (languageResponse?.Language_Code) {
            localStorage.setItem('user_language', languageResponse.Language_Code);
        }

        await dispatch({ type: "GET_USERTRANSLATELANGUAGEACTION", payload: languageResponse });
        return languageResponse;
    }
    catch (error) {
        dispatch({ type: "GET_USERTRANSLATELANGUAGEACTION_FAILED", payload: error.response?.data });
        throw error;
    };
}
const videoDetailsAction = (slug, access, loader) => async (dispatch) => {
    if (access && Object.keys(access).length) {
        const shouldDispatch = (!getItem('role') && access?.access_free == 1) || getItem('role');
        if (shouldDispatch) {
            loader && dispatch({ type: "GET_VIDEODETAILSACTION_REQUEST" })
            try {
                const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/video-details`, {
                    Login_user_type: parseInt(getItem('role'), 10) || 9,
                    Login_device_type: "web",
                    Login_user_id: parseInt(getItem('user_id'), 10) || null,
                    slug: slug
                }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', } })
                const videoResponse = response?.data?.data;
                if (videoResponse?.Recommended_videos?.data) {
                    videoResponse.Recommended_videos.data = filterKidsContent(videoResponse.Recommended_videos.data);
                }
                const videocommentSettings = response?.data?.adminCommentSection;
                const videoButtonResponse = response?.data?.ButtonTextSettings;
                dispatch({ type: "GET_VIDEODETAILSACTION", payload: videoResponse, videocommentSettings: videocommentSettings, videoButtonResponse: videoButtonResponse });
            }
            catch (error) {
                dispatch({ type: "GET_VIDEODETAILSACTION_FAILED", payload: error.response?.data });
            };
        }
    }
}
const userDetailsAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/user-details`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const userdetailsdata = response?.data
        dispatch({ type: "GET_USERDETAILSACTION", payload: userdetailsdata, });
    }
    catch (error) {
        dispatch({ type: "GET_USERDETAILSACTION_FAILED", payload: error.response?.data });
    };
}

const userPermissionAction = () => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/user-permissions`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const permissionData = response?.data
        dispatch({ type: "GET_USER_PERMISSION", payload: permissionData });
    }
    catch (error) {
        dispatch({ type: "GET_USER_PERMISSION_FAILED", payload: error.response?.data });
    };
}

// const seriesDetailsAction = (userId, userType, deviceType, slug,accessHeader) => async (dispatch) => {
//     try {
//         const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Series-details`, {
//             Login_user_type: userType,
//             Login_device_type: deviceType,
//             Login_user_id: userId,
//             series_slug: slug,
//         }, { headers: accessHeader })
//         const seriesPPVResponse = response?.data;
//         const seriesResponse = response?.data?.series_details;
//         dispatch({ type: "GET_SERIESDETAILSACTION", payload: seriesResponse, 
//             seriesPPVResponse:seriesPPVResponse });
//         return {seriesPPVResponse,seriesResponse};
//     }
//     catch (error) {
//         dispatch({ type: "GET_SERIESDETAILSACTION_FAILED", payload: error.response?.data });
//     };
// }

const seriesDetailsAction = (userId, userType, deviceType, slug, accessHeader) => async (dispatch) => {
    dispatch({ type: "GET_SERIESDETAILSACTION_REQUEST" });
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Series-details`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
            slug: slug,
        }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json' } });
        const seriesResponse = response?.data?.responseData;
        if (seriesResponse?.Recommended_videos?.data) {
            seriesResponse.Recommended_videos.data = filterKidsContent(seriesResponse.Recommended_videos.data);
        }
        dispatch({ type: "GET_SERIESDETAILSACTION", payload: seriesResponse });
        return seriesResponse;
    } catch (error) {
        console.error('Error during API call:', error);
        dispatch({ type: "GET_SERIESDETAILSACTION_FAILED", payload: error.response?.data || error.message });
    }
}


const episodeDetailsAction = (userId, userType, deviceType, episode_slug, episode_id) => async (dispatch) => {
    dispatch({ type: "GET_EPISODEDETAILSACTION_REQUEST" });
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Episode-details`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
            slug: episode_slug,
            id: episode_id
        }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json' } })
        const episodeResponse = response?.data;
        if (episodeResponse?.Recommended_videos?.data) {
            episodeResponse.Recommended_videos.data = filterKidsContent(episodeResponse.Recommended_videos.data);
        }
        const episodecommentSettings = response?.data?.adminCommentSection;
        dispatch({ type: "GET_EPISODEDETAILSACTION", payload: episodeResponse, episodecommentSettings: episodecommentSettings });
        return episodeResponse;

    }
    catch (error) {
        dispatch({ type: "GET_EPISODEDETAILSACTION_FAILED", payload: error });
    };
}
const seasonDetailsAction = (userId, userType, deviceType, series_slug, season_id) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/series-season-details`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: 'web',
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            series_slug: series_slug,
            season_id: season_id
        }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json' } })
        const seasonResponse = response?.data?.responseData;
        dispatch({ type: "GET_SEASONDETAILSACTION", payload: seasonResponse });
        return seasonResponse;

    }
    catch (error) {
        dispatch({ type: "GET_SEASONDETAILSACTION_FAILED", payload: error });
    };
}

const liveDetailsAction = (userId, userType, deviceType, slug, accessHeader) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Livestream-details`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            slug: slug
        }, {
            headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', }
        })
        const liveResponse = response?.data?.data;
        const liveResponsePayment_setting = response?.data?.Payment_setting;
        const livecommentSettings = response?.data?.adminCommentSection;
        dispatch({ type: "GET_LIVEDETAILSACTION", payload: liveResponse, liveResponsePayment_setting: liveResponsePayment_setting, livecommentSettings: livecommentSettings });
    }

    catch (error) {
        dispatch({ type: "GET_LIVEDETAILSACTION_FAILED", payload: error.response?.data });
    };
}
// other_audios
const artistsDetailsAction = (userId, userType, deviceType, slug,page = 1) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/artists-depends-videos`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
            artist_slug: slug,
            page,
        }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', } })
        const artistResponse = response?.data;
        dispatch({ type: "GET_ARTISTS_DETAILS_ACTION", payload: artistResponse });
    }
    catch (error) {
        dispatch({ type: "GET_ARTISTS_DETAILS_ACTION_FAILED", payload: error });
    };
}

const linearPlayoutAction = (slug) => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Linear-channel/${slug}`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        const playoutResponse = response?.data;
        dispatch({ type: "GET_LINEAR_PLAYOUT_ACTION", payload: playoutResponse });
    } catch (error) {
        dispatch({ type: "GET_LINEAR_PLAYOUT_ACTION_FAILED", payload: error });
    }
}

const hlsSignalAction = (url) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_Baseurl}/api/check-hls-signal`,
            { hls_url: url },
        );
        const signalResponse = response?.data;
        dispatch({ type: "GET_HLS_SIGNAL_ACTION", payload: signalResponse });
    } catch (error) {
        dispatch({ type: "GET_HLS_SIGNAL_ACTION_FAILED", payload: error });
    }
}

const viewerRegister = (streamId, clientId) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/api/viewers/register`, {
            streamId: streamId,
            clientId: clientId,
        });
        console.log("responseee", response?.data);
        dispatch({ type: "GET_VIEWER_REGISTER_ACTION", payload: response?.data });
    } catch (error) {
        dispatch({ type: "GET_VIEWER_REGISTER_FAILED", payload: error });
    }
}

const heartBeat = (streamId, clientId) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/api/viewers/heartbeat`, {
            streamId: streamId,
            clientId: clientId,
        });
        dispatch({ type: "GET_HEARTBEAT_ACTION", payload: response?.data });
    } catch (error) {
        dispatch({ type: "GET_HEARTBEAT_FAILED", payload: error });
    }
}

const viewerCount = (streamId) => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/api/viewers/count`, {
            params: { streamId: streamId }
        });
        dispatch({ type: "GET_VIEWER_COUNT_ACTION", payload: response });
    } catch (error) {
        dispatch({ type: "GET_VIEWER_COUNT_FAILED", payload: error });
    }
}

const viewerUnregister = (streamId, clientId) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/api/viewers/unregister`, {
            streamId: streamId,
            clientId: clientId,
        });
        dispatch({ type: "GET_VIEWER_UNREGISTER_ACTION", payload: response });
    } catch (error) {
        dispatch({ type: "GET_VIEWER_UNREGISTER_FAILED", payload: error });
    }
}

const channelDetailsAction = (userId, userType, deviceType, slug) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
            artist_slug: slug,
        })
        const liveResponse = response?.data?.Livestream_details;
        dispatch({ type: "GET_CHANNEL_DETAILS_ACTION", payload: liveResponse });
    }
    catch (error) {
        dispatch({ type: "GET_CHANNEL_DETAILS_ACTION_FAILED", payload: error });
    };
}
const contentDetailsAction = (userId, userType, deviceType, slug) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
            artist_slug: slug,
        })
        const liveResponse = response?.data?.Livestream_details;
        dispatch({ type: "GET_CONTENT_DETAILS_ACTION", payload: liveResponse });
    }
    catch (error) {
        dispatch({ type: "GET_CONTENT_DETAILS_ACTION_FAILED", payload: error });
    };
}
const allHomePageAction = (page = 1) => async (dispatch) => {
    dispatch({ type: "GET_ALLHOMEPAGE_REQUEST", meta: { isAppend: page > 1 } });
    try {
        const apiUrl = `${process.env.REACT_APP_Baseurl}/Front-End/home-page`;

        const postData = {
            Login_device_type: "web",
            page,
            kids_mode: localStorage.getItem("kids_mode") === "1" ? 1 : 0,
        };

        const headers = {
            headers:
                getItemToken("access_token") || {
                    guestverfiykey: "WebVodWebnexs",
                    "Content-Type": "application/json",
                },
        };

        const response = await axios.post(apiUrl, postData, headers);

        const resData = response?.data || {};
        const homePageData = resData?.Home_page || [];

        dispatch({
            type: "GET_ALLHOMEPAGE_ACTION",
            payload: homePageData,
            meta: {
                currentPage: resData?.currentPage || page,
                totalPages: resData?.totalPages || 1,
                sectionsPerPage: resData?.sectionsPerPage || 10,
                totalSections: resData?.totalSections || 0,
                hasMore: resData?.hasMore,
                nextPage: resData?.nextPage,
                isAppend: page > 1,
            },
        });
    } catch (error) {
        // Check if this is the specific "Invalid section type" error
        if (error?.response?.data?.message?.includes("Invalid section type")) {
            console.error('Backend section type error:', error?.response?.data?.message);
            // Still dispatch success with empty data rather than failing completely
            dispatch({
                type: "GET_ALLHOMEPAGE_ACTION",
                payload: [],
                meta: {
                    currentPage: 1,
                    totalPages: 1,
                    sectionsPerPage: 0,
                    totalSections: 0,
                    hasMore: false,
                    nextPage: null,
                    isAppend: false,
                    error: 'Some sections could not be loaded due to configuration issues'
                },
            });
        } else {
            dispatch({ type: "GET_ALLHOMEPAGE_FAILED", payload: error });
        }
    }
}
const specificHomePageAction = (homepageSource, currentPage = 1) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/specific-homepage`, {
            homepage_source: homepageSource,
            page: currentPage,
            Login_device_type: "web",
        },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            }
        );

        const homePageData = response?.data?.Home_page || [];
        const hasMoreData = homePageData && homePageData.length > 0;

        dispatch({ type: "GET_SPECIFIC_HOMEPAGE_ACTION", payload: homePageData, meta: { page: currentPage, hasMore: hasMoreData, isAppend: currentPage > 1 } });
    } catch (error) {
        dispatch({ type: "GET_SPECIFIC_HOMEPAGE_FAILED", payload: error });
    }
}
const movieHomePageAction = (page, limit) => async (dispatch) => {
    try {
        // Ensure parameters are safe and valid
        const safePage = Math.max(1, parseInt(page) || 1);
        const safeLimit = Math.min(Math.max(1, parseInt(limit) || 10), 100); // Cap at 100 to prevent large queries

        console.log('Movie HomePage Action - Safe params:', { safePage, safeLimit });

        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/movies-home-page`,
            {
                Login_user_type: parseInt(getItem('role'), 10) || 9,
                Login_device_type: "web",
                page: safePage,
                limit: safeLimit,
                Login_user_id: parseInt(getItem('user_id'), 10) || null,
            },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                },
                timeout: 15000 // 15 second timeout
            }
        );

        if (response?.data?.status !== false && response?.data?.Home_page) {
            dispatch({ type: "MOVIE_HOMEPAGE", payload: response?.data?.Home_page });
        } else {
            console.warn('Movie HomePage API returned empty or error response:', response?.data);
            dispatch({ type: "MOVIE_HOMEPAGE", payload: [] });
        }

    } catch (error) {
        console.error('Movie HomePage Action Error:', {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
            params: { page, limit }
        });

        // Provide fallback empty data instead of failing
        dispatch({ type: "MOVIE_HOMEPAGE", payload: [] });
    }
}

const showHomePageAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/tv-shows-home-page`,
            {
                Login_device_type: "web",
                limit: 10,
                page: 1
            },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                },
                timeout: 15000 // 15 second timeout
            }
        );

        if (response?.data?.status !== false && response?.data?.Home_page) {
            dispatch({ type: "SHOW_HOMEPAGE", payload: response?.data?.Home_page });
        } else {
            console.warn('Show HomePage API returned empty or error response:', response?.data);
            dispatch({ type: "SHOW_HOMEPAGE", payload: [] });
        }

    } catch (error) {
        console.error('Show HomePage Action Error:', {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });

        // Provide fallback empty data instead of failing
        dispatch({ type: "SHOW_HOMEPAGE", payload: [] });
    }
}

const liveHomePageAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/livestream-home-page`,
            {
                Login_device_type: "web",
                limit: 10,
                page: 1
            },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                },
                timeout: 15000 // 15 second timeout
            }
        );

        if (response?.data?.status !== false && response?.data?.Home_page) {
            dispatch({ type: "LIVE_HOMEPAGE", payload: response?.data?.Home_page });
        } else {
            console.warn('Live HomePage API returned empty or error response:', response?.data);
            dispatch({ type: "LIVE_HOMEPAGE", payload: [] });
        }

    } catch (error) {
        console.error('Live HomePage Action Error:', {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });

        // Provide fallback empty data instead of failing
        dispatch({ type: "LIVE_HOMEPAGE", payload: [] });
    }
}

const sportsHierarchyAction = (slug) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/livestream-category-hierarchy`,
            {
                Login_device_type: "web",
                category_slug: slug,
            },
            {
                headers: getItemToken('access_token') || {
                    'guestverfiykey': "WebVodWebnexs",
                    'Content-Type': 'application/json',
                }
            }
        );

        if (response?.data?.status) {
            dispatch({ type: "GET_SPORTS_HIERARCHY", payload: response?.data?.data });
        } else {
            dispatch({ type: "GET_SPORTS_HIERARCHY_FAILED", payload: response?.data?.message });
        }
    } catch (error) {
        dispatch({ type: "GET_SPORTS_HIERARCHY_FAILED", payload: error.message });
    }
}


const allThumbnailAction = (accessHeader) => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Thumbnail-Status`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data?.Thumbnail_Status
        dispatch({ type: "GET_THUMBNAIL_ACTION", payload: ListRes });
    }
    catch (error) {
        dispatch({ type: "GET_THUMBNAIL_ACTION_FAILED", payload: error });
    };
}
const headerIndexAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Header-index`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data
        dispatch({ type: "GET_HEADERINDEX_ACTION", payload: ListRes });
    }
    catch (error) {
        dispatch({ type: "GET_HEADERINDEX_ACTION_FAILED", payload: error });
    };
}

const profileDetailsAction = () => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Profile-details`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data
        dispatch({ type: "GET_PROFILE_ACTION", payload: ListRes });
    }
    catch (error) {
        dispatch({ type: "GET_PROFILE_ACTION_FAILED", payload: error });
    };
}

const ageCategoryAction = (accessHeader) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_Baseurl}/admin/age-category/index`,
            { headers: accessHeader }
        );
        const ListRes = response?.data?.Home_page;
        dispatch({ type: "GET_AGECATEGORY_ACTION", payload: ListRes });
    } catch (error) {
        dispatch({ type: "GET_AGECATEGORY_ACTION_FAILED", payload: error });
    }
}

const viewAllPageAction = (page, deviceType, requestApi) => async (dispatch) => {
    dispatch({ type: "GET_VIEWALLPAGE_REQUEST" });
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/page-list`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: deviceType || "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            page: page ? page : 1,
            homepage_source: requestApi,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        const viewAllData = response?.data;
        if (viewAllData?.Pagelist) {
            viewAllData.Pagelist = filterKidsContent(viewAllData.Pagelist);
        }
        dispatch({ type: "GET_VIEWALLPAGE_ACTION", payload: viewAllData });
        return viewAllData;
    }
    catch (error) {
        dispatch({ type: "GET_VIEWALLPAGE_FAILED", payload: error });
        throw error;
    };
}
const viewAllCategoryPageAction = (categorySource, sectionLimit, pageNumber) => async (dispatch) => {
    dispatch({ type: "GET_VIEWALLCATEGORYPAGE_REQUEST" });
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/page-list`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            page: pageNumber ? pageNumber : 1,
            limit: sectionLimit || 12,
            homepage_source: categorySource
        }, {
            headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', }
        })
        const ListRes = response?.data;
        if (ListRes?.Pagelist) {
            ListRes.Pagelist = filterKidsContent(ListRes.Pagelist);
        }
        dispatch({ type: "GET_VIEWALLCATEGORYPAGE_ACTION", payload: ListRes });
        return ListRes;
    }
    catch (error) {
        dispatch({ type: "GET_VIEWALLCATEGORYPAGE_FAILED", payload: error });
    };
}

const languagePageListAction = (userId, userType, deviceType, accessHeader, requestApi) => async (dispatch) => {
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
            limit: 10,
            page: 1
        }, {
            headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', }
        })
        const ListRes = response?.data?.languages?.data
        dispatch({ type: "GET_LANGUAGE_PAGE_LIST_ACTION", payload: ListRes });
        return ListRes;
    }
    catch (error) {
        dispatch({ type: "GET_LANGUAGE_PAGE_LIST_FAILED", payload: error });
    };
}
const liveCategoriesPageListAction = (userId, userType, deviceType, accessHeader, requestApi) => async (dispatch) => {
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, { headers: accessHeader })
        const ListRes = response?.data?.data
        dispatch({ type: "GET_LIVECAT_PAGE_LIST_ACTION", payload: ListRes });
        return ListRes
    }
    catch (error) {
        dispatch({ type: "GET_LIVECAT_PAGE_LIST_FAILED", payload: error });
    };
}
const videoCategoriesPageListAction = (userId, userType, deviceType, accessHeader, requestApi) => async (dispatch) => {
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, { headers: accessHeader })
        const ListRes = response?.data?.data
        dispatch({ type: "GET_VIDEOCAT_PAGE_LIST_ACTION", payload: ListRes });
        return ListRes
    }
    catch (error) {
        dispatch({ type: "GET_VIDEOCAT_PAGE_LIST_FAILED", payload: error });
    };
}

const seriesCategoriesPageListAction = (userId, userType, deviceType, accessHeader, requestApi) => async (dispatch) => {
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, { headers: accessHeader })
        const ListRes = response?.data?.data
        dispatch({ type: "GET_SERIESCAT_PAGE_LIST_ACTION", payload: ListRes });
        return ListRes
    }
    catch (error) {
        dispatch({ type: "GET_SERIESCAT_PAGE_LIST_FAILED", payload: error });
    };
}
const audioCategoriesPageListAction = (userId, userType, deviceType, accessHeader, requestApi) => async (dispatch) => {
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, { headers: accessHeader })
        const ListRes = response?.data?.data
        dispatch({ type: "GET_AUDIOCAT_PAGE_LIST_ACTION", payload: ListRes });
        return ListRes
    }
    catch (error) {
        dispatch({ type: "GET_AUDIOCAT_PAGE_LIST_FAILED", payload: error });
    };
}
const viewAllPageIdAction = (deviceType, ID, page, requestApi) => async (dispatch) => {
    dispatch({ type: "GET_VIEWALLPAGEID_REQUEST" });
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_device_type: deviceType,
            language_id: ID,
            page: page,
        }, { headers: getItemToken('access_token') || { 'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json', } })
        const ListRes = response?.data?.languages
        dispatch({ type: "GET_VIEWALLPAGEID_ACTION", payload: ListRes });

    }
    catch (error) {
        dispatch({ type: "GET_VIEWALLPAGEID_FAILED", payload: error });
    };
}
const viewAllPageCategoryIdAction = (slug, requestApi, page, homepage_source) => async (dispatch) => {
    dispatch({ type: "GET_VIEWALLPAGECATID_REQUEST" });
    try {
        const response = await axios.post(`${requestApi}`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            page: page || 1,
            limit: 10,
            category_slug: slug,
            homepage_source: homepage_source,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json'
            },
            timeout: 15000 // 15 second timeout
        });

        const ListRes = response?.data;

        // Validate response data structure
        if (ListRes && typeof ListRes === 'object') {
            dispatch({ type: "GET_VIEWALLPAGECATID_ACTION", payload: ListRes });
        } else {
            console.warn('Invalid response structure:', ListRes);
            dispatch({
                type: "GET_VIEWALLPAGECATID_ACTION",
                payload: {
                    videos: { data: [], pagination: {} },
                    Livestream: { data: [], pagination: {} },
                    series: { data: [], pagination: {} },
                    Audios: { data: [], pagination: {} }
                }
            });
        }
    }
    catch (error) {
        console.error('API Error in viewAllPageCategoryIdAction:', {
            slug,
            requestApi,
            page,
            error: error.response?.data || error.message,
            status: error.response?.status
        });

        // Provide fallback data structure instead of just error
        dispatch({
            type: "GET_VIEWALLPAGECATID_ACTION",
            payload: {
                videos: { data: [], pagination: {} },
                Livestream: { data: [], pagination: {} },
                series: { data: [], pagination: {} },
                Audios: { data: [], pagination: {} },
                error: {
                    message: 'Failed to load content',
                    details: error.response?.data?.message || error.message,
                    status: error.response?.status
                }
            }
        });
    };
}
const getwatchLaterListAction = (userId, userType, deviceType, accessHeader) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Watchlater-Contents`, {
            Login_device_type: deviceType,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = filterKidsObjectArrays(response?.data?.watchlater);
        dispatch({ type: "GET_WATCHLATERLIST_ACTION", payload: ListRes });

    }
    catch (error) {
        dispatch({ type: "GET_WATCHLATERLIST_FAILED", payload: error });
    };
}
const getWishListAction = (userId, userType, deviceType, accessHeader) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Wishlist-Contents`, {
            Login_device_type: "web",
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = filterKidsObjectArrays(response?.data?.wishlistList);
        dispatch({ type: "GET_WISHLIST_ACTION", payload: ListRes });

    }
    catch (error) {
        dispatch({ type: "GET_WISHLIST_FAILED", payload: error });
    };
}
const getMyListAction = (userId, userType, deviceType, accessHeader) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/My-List`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data;
        dispatch({ type: "GET_MYLIST_ACTION", payload: ListRes });
    } catch (error) {
        dispatch({ type: "GET_MYLIST_FAILED", playload: error });
    }
}
const getRecentViewsAction = (userId, userType, deviceType, accessHeader) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Recent-views-List`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data;
        // console.log("Recent Views", ListRes);
        dispatch({ type: "GET_RECENTVIEWS_ACTION", payload: ListRes });
    } catch (error) {
        dispatch({ type: "GET_RECENTVIEWS_FAILED", payload: error });
    }
}
const getPlayerSettings = (userId, userType, deviceType) => async (dispatch) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/video-player-settings`, {
            Login_user_type: userType,
            Login_device_type: deviceType,
            Login_user_id: userId,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        console.log("responseee", response);
        const playerSettings = response?.data?.data?.settings;
        dispatch({ type: "GET_PLAYER_SETTINGS_ACTION", payload: playerSettings });
    } catch (error) {
        dispatch({ type: "GET_PLAYER_SETTINGS_FAILED", payload: error });
    }
}

const getMusicSettingsAction = (accessHeader) => async (dispatch) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Music-theme-setting`, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const ListRes = response?.data?.Music_Setting
        // console.log(ListRes, 'listres')
        dispatch({ type: "GET_MUSIC_ACTION", payload: ListRes });
    }
    catch (error) {
        dispatch({ type: "GET_MUSIC_FAILED", payload: error });
    };
}

const userChangeLanguage = (code, navigate) => async (dispatch) => {
    dispatch({ type: "GET_USERTRANSLATELANGUAGEACTION_REQUEST" });
    try {
        await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Choose-Language`, {
            Language_Code: code,
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            Login_device_type: "web",
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        dispatch(getUserTranslateLanguageAction(navigate))
    } catch (error) {
    }
}
const userTranslateLanguage = async () => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/User-Translate-Language`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || '',
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        })
        const languageResponse = response?.data;

        return languageResponse;
    }
    catch (error) {

    };
}

let isToastShown = false;

const isBlacklistedLogoutMessage = (message) => {
    const normalized = String(message || '').toLowerCase();
    return normalized.includes('already been blacklisted') ||
        normalized.includes('token has been blacklisted') ||
        normalized.includes('blacklisted');
};


const LogOutApi = (navigate) => async (dispatch) => {
    // Check if the user is logged in by verifying the presence of access_token
    const token = localStorage.getItem('access_token');
    if (!token) {
        console.warn('User is not logged in. Logout skipped.');
        return; // Exit if the user is not logged in
    }

    try {
        const logoutResponse = await axios.get(`${process.env.REACT_APP_Baseurl}/users/logout`, {
            headers: getItemToken('access_token'),
            timeout: 10000
        });

        const logoutMessage = logoutResponse?.data?.message;
        const logoutSucceeded = logoutResponse?.data?.status || isBlacklistedLogoutMessage(logoutMessage);

        if (logoutSucceeded) {
            if (!isToastShown) {
                toast.success(logoutMessage || 'Logout successfully');
                isToastShown = true; // Set flag to prevent further toasts
            }

            const isPartnerUser = String(localStorage.getItem('role') || '') === '4';

            await dispatch(getUserTranslateLanguageAction(navigate));
            dispatch({ type: "OPEN_PLAYLIST", payload: false });
            dispatch({ type: "GET_AUDIO_SUCCESS", payload: null });
            dispatch({ type: "GET_CURRENT_SUCCESS", payload: null });
            dispatch({ type: "GET_CLOSE_SUCCESS", isClose: false });

            // Clear localStorage after successfully dispatching
            localStorage.clear();

            navigate(isPartnerUser ? '/partner' : '/'); // Partner users go to partner login, everyone else goes home
        } else {
            toast.error(logoutMessage || 'Logout failed');
        }
    } catch (logoutError) {
        const errorMessage = logoutError?.response?.data?.message || logoutError?.message;
        const isAlreadyBlacklisted = isBlacklistedLogoutMessage(errorMessage);

        // Treat already-blacklisted token as a clean logout, not an error.
        if (logoutError?.response?.status === 403 || logoutError?.response?.status === 401 || isAlreadyBlacklisted) {
            console.warn('Logout token was already blacklisted; treating as successful sign-out.');
            localStorage.clear();
            if (!isToastShown) {
                toast.success('Logout successfully');
                isToastShown = true;
            }
            navigate('/');
        } else {
            console.error('Logout error:', logoutError);
            toast.error(errorMessage || 'Logout failed');
        }
    }
};



const useAutoLogout = (navigate) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        const expires_in_seconds = parseInt(localStorage.getItem("expires_in"), 10);

        if (!token) {
            console.warn('No token found. Auto logout is disabled.');
            return;
        }

        if (!expires_in_seconds || isNaN(expires_in_seconds)) {
            console.warn('No valid expiration time found. Auto logout is disabled.');
            return;
        }

        // Always write/refresh loginTime when the hook mounts with a valid token.
        // This ensures that after a new login the timer resets correctly.
        let loginTime = localStorage.getItem('loginTime');
        if (!loginTime) {
            loginTime = new Date().toISOString();
            localStorage.setItem('loginTime', loginTime);
        }

        const loginTimestamp = new Date(loginTime).getTime();
        const totalExpireMs = expires_in_seconds * 1000;
        const elapsedMs = Date.now() - loginTimestamp;
        const remainingMs = totalExpireMs - elapsedMs;

        if (remainingMs <= 0) {
            // Token has already expired — log out immediately
            dispatch(LogOutApi(navigate));
            return;
        }

        // Cap at JS 32-bit signed int max (~24.8 days) to avoid timer overflow
        const safeRemainingMs = Math.min(remainingMs, 2147483647);

        const expirationTimeout = setTimeout(() => {
            dispatch(LogOutApi(navigate));
        }, safeRemainingMs);

        return () => {
            clearTimeout(expirationTimeout);
        };
    }, [dispatch, navigate]);
};

// const useAutoLogout = (expires_in, navigate) => {
//     const dispatch = useDispatch();

//     useEffect(() => {
//         const token = localStorage.getItem('access_token'); // Check for the token
//         if (!token) {
//             console.warn('No token found. Auto logout is disabled.');
//             return; // Exit if there is no token
//         }

//         const loginTime = localStorage.getItem('loginTime');
//         let remainingTime = expires_in * 1000; // Convert expires_in to milliseconds

//         if (loginTime) {
//             const elapsedTime = Date.now() - new Date(loginTime).getTime();
//             remainingTime = remainingTime - elapsedTime; // Calculate remaining time based on elapsed time

//             if (remainingTime <= 0) {
//                 // If the token has already expired, log out immediately
//                 dispatch(LogOutApi(navigate));
//             } else {
//                 // Set a timeout to log the user out when the token expires
//                 const expirationTimeout = setTimeout(() => {
//                     dispatch(LogOutApi(navigate));
//                 }, remainingTime);

//                 // Clear the timeout if the component unmounts
//                 return () => clearTimeout(expirationTimeout);
//             }
//         } else {
//             // Store the current time as the login time if not already stored
//             localStorage.setItem('loginTime', new Date().toISOString());
//         }
//     }, [expires_in, dispatch, navigate]);
// };


// const LogOutApi = (navigate) => async (dispatch) => {
//     try {
//         const logoutResponse = await axios.get(`${process.env.REACT_APP_Baseurl}/users/logout`, {
//             headers: getItemToken('access_token'),
//         });

//         if (logoutResponse?.data?.status) {
//             if (!isToastShown) { // Show toast only if not shown already
//                 toast.success(logoutresponse?.data?.message);
//                 isToastShown = true; // Set flag to prevent further toasts
//             }

//             await dispatch(getUserTranslateLanguageAction(navigate));
//             dispatch({ type: "OPEN_PLAYLIST", payload: false });
//             dispatch({ type: "GET_AUDIO_SUCCESS", payload: null });
//             dispatch({ type: "GET_CURRENT_SUCCESS", payload: null });
//             dispatch({ type: "GET_CLOSE_SUCCESS", isClose: false });

//             // Clear localStorage after successfully dispatching
//             localStorage.clear();

//             navigate('/'); // Ensure redirection after logout if needed
//         } else {
//             toast.error(logoutresponse?.data?.message);
//         }
//     } catch (logoutError) {
//         console.error('Logout error:', logoutError);
//     }
// };


// const useAutoLogout = (expires_in, navigate) => {
//     const dispatch = useDispatch();

//     useEffect(() => {
//         const loginTime = localStorage.getItem('loginTime');
//         let remainingTime = expires_in * 1000; // Convert expires_in to milliseconds

//         if (loginTime) {
//             const elapsedTime = Date.now() - new Date(loginTime).getTime();
//             remainingTime = remainingTime - elapsedTime; // Calculate remaining time based on elapsed time

//             if (remainingTime <= 0) {
//                 // If the token has already expired, log out immediately
//                 dispatch(LogOutApi(navigate));
//             } else {
//                 // Set a timeout to log the user out when the token expires
//                 const expirationTimeout = setTimeout(() => {
//                     dispatch(LogOutApi(navigate));
//                 }, remainingTime);

//                 // Clear the timeout if the component unmounts
//                 return () => clearTimeout(expirationTimeout);
//             }
//         } else {
//             // Store the current time as the login time if not already stored
//             localStorage.setItem('loginTime', new Date().toISOString());
//         }
//     }, [expires_in, dispatch, navigate]);
// };

const getFieldEnable = () => async (dispatch) => {
    await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/SignupMenu-Settings`, {
        headers: getItemToken('access_token') || {
            'guestverfiykey': "WebVodWebnexs",
            'Content-Type': 'application/json',
        }
    }).then((res) => {
        dispatch({ type: "SIGNUP-SETTINGS", payload: res?.data?.signup_menu });
    }).catch(() => {
        console.error("Error")
    })
}

const commentsIndex = (sourceId, sourceType) => async (dispatch) => {
    try {
        const token = await getItemToken('access_token');
        const response = await axios.post(
            `${process.env.REACT_APP_Baseurl}/Front-End/comments`,
            {  // Request Body (for POST)
                // Login_user_type: parseInt(getItem('role'), 10) || 9,
                Login_device_type: "web",
                // Login_user_id: parseInt(getItem('user_id'), 10) || null,
                source_id: sourceId,
                source_type: sourceType
            }, {
            headers: await getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs", 'Content-Type': 'application/json'
            }
        });
        const comments = response?.data?.comments;
        // console.log(comments,'response.data')
        dispatch({ type: "GET_COMMENT_ACTION", payload: comments });
    } catch (error) {
        console.error('Error during API call:', error);
        dispatch({ type: "GET_COMMENT_FAILED", payload: error.response?.data || error.message });
    }
};

const clearViewAllList = () => ({ type: "CLEAR_VIEWALLLIST" });
export { userPermissionAction, userDetailsAction, getFieldEnable, liveHomePageAction, showHomePageAction, movieHomePageAction, LogOutApi, useAutoLogout, userTranslateLanguage, userChangeLanguage, footerAction, homeBannerAction, viewAllAction, settingAction, labelAction, filterAction, siteThemeAction, displayTranslateLanguageAction, getUserTranslateLanguageAction, videoDetailsAction, seriesDetailsAction, seasonDetailsAction, liveDetailsAction, clearViewAllList, allHomePageAction, specificHomePageAction, channelDetailsAction, contentDetailsAction, allThumbnailAction, headerIndexAction, profileDetailsAction, ageCategoryAction, viewAllPageAction, languagePageListAction, viewAllPageIdAction, liveCategoriesPageListAction, viewAllPageCategoryIdAction, videoCategoriesPageListAction, seriesCategoriesPageListAction, audioCategoriesPageListAction, episodeDetailsAction, getwatchLaterListAction, getWishListAction, getMyListAction, getRecentViewsAction, getPlayerSettings, getMusicSettingsAction, artistsDetailsAction, linearPlayoutAction, hlsSignalAction, viewerRegister, heartBeat, viewerCount, viewerUnregister, commentsIndex, viewAllCategoryPageAction, sportsHierarchyAction }
